import React from "react";

const CTASection = () => {
  return (
    <section className="cta-section mb-5">
      <div className="cta-overlay">
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT CONTENT */}
            <div className="col-lg-8 mb-4 mb-lg-0">
              <h2>
                Partner with <span>Goodweel Crop Care</span>
              </h2>
              <p>
                Empower your farming journey with reliable, eco-friendly,
                and high-performance crop protection solutions.
                Let’s grow healthier crops and a sustainable future together.
              </p>
            </div>

            {/* RIGHT BUTTONS */}
            <div className="col-lg-4 text-lg-end">
              <a href="/contact" className="cta-btn primary">
                Contact Us
              </a>
              <a href="mailto:Goodweelcropcare@gmail.com" className="cta-btn secondary">
                Become a Distributor
              </a>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
